import { useState } from 'react'
import Accordion from './Accordion'

const AccordionList = () => {
    const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const accordionData = [
    {
      title: ' How do I register/login to the application?',
      content:
         'To register, open the app and click on "Get Started". Fill in your details (name, email, phone number, password and address) and submit. If you already have an account, click "Login", enter your email and password, and you will be redirected to your dashboard.',
    },
    {
      title: 'How do I submit a maintenance issue?',
      content:
        'Tenants can submit a maintenance request by navigating to the "Maintenance" section of the app, selecting the issue type (e.g., plumbing, electrical), and providing a detailed description and photos. The property manager will be notified instantly and can assign a service provider.',
    },
    {
      title: 'How do I contact the property manager/administrator?',
      content:
        'You can contact the property manager through the "Contact Us" section of the application.',
    },
    // {
    //   title: 'Can I add multiple properties to my account?',
    //   content:
    //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    // },
  ]

    const handleToggle = (index: number) => {
      setActiveIndex((prev) => (prev === index ? null : index))
    }

  return (
    <>
      <div className="flex flex-col gap-5 relative z-30 mt-12 lg:mt-20">
        {accordionData.map((item, index) => (
          <Accordion
            key={index}
            title={item.title}
            content={item.content}
            isOpen={activeIndex === index} 
            onClick={() => handleToggle(index)} 
          />
        ))}
      </div>
    </>
  )
}

export default AccordionList
